import React, { useState, useEffect } from "react";
import { Inner } from "./styles";
import { Form, Input, Button, Select, DatePicker, Row, Divider, Col } from "antd";
import moment from "moment";
import { Footer } from "../../../../styles";
import FloatingLabel from "../../../../../floatingLabel/FloatingLabel";
import { ButtonsFixedFooter, Buttons } from "../../styles";
import { get_credit_card_providers, get_credit_card_types } from "../../../../../../../api/endpoints/sysone-endpoints/sysoneEndpoints";

const { Option } = Select;

export default function CreatePaymentCredit({
	onCreate,
	setAddPaymentMethodMode,
	handleInputChange,
	handleInputFocus,
	fixedFooter,
	onCancel
}) {

	const [form] = Form.useForm();
	const [creditCardTypes, setCreditCardTypes] = useState([]);
	const [creditCardProviders, setCreditCardProviders] = useState([]);
	const [focused, setFocused] = useState("");
	// Se guarda el objeto moment seleccionado en el DatePicker de forma local,
	// en lugar de depender únicamente de values.expiry provisto por el
	// onFinish del Form. Se detectó que, en este formulario en particular,
	// values.expiry podía llegar undefined al submit (posiblemente por cómo
	// Ant Design compone el "trigger" del Form.Item junto con el onChange
	// personalizado sobre un DatePicker con picker="month"), haciendo que
	// moment(undefined) resuelva a la fecha/hora actual en vez de la
	// seleccionada por el usuario. Como el onChange del DatePicker sí recibe
	// siempre el valor correcto (se verifica porque la vista previa de la
	// tarjeta -Cards- lo muestra bien), lo capturamos acá para usarlo como
	// fuente de verdad al construir dateTo.
	const [selectedExpiry, setSelectedExpiry] = useState(null);


	const formatCardNumber = (e) => {
		const value = e.target.value
		// Elimina todo lo que no sea un número
		const numericValue = value.replace(/\D/g, '');

		handleInputChange(numericValue, "cardNumber")
		// Limita a 16 dígitos
		const truncatedValue = numericValue.slice(0, 16);
		// Formatea cada 4 dígitos
		return truncatedValue.replace(/(\d{4})(?=\d)/g, '$1-');
	};

	const handleChange = (e) => {
		e.preventDefault()
		const formattedValue = formatCardNumber(e);
		form.setFieldsValue({ number: formattedValue });
	};

	const formValues = Form.useWatch([], form);

	useEffect(() => {
		fetch_credit_card_types();
		fetch_credit_card_providers();
	}, []);

	const fetch_credit_card_types = async () => {
		const data = await get_credit_card_types()
		setCreditCardTypes(data.values || []);
	};

	const fetch_credit_card_providers = async () => {
		const data = await get_credit_card_providers()
		setCreditCardProviders(data.values || []);
	};

	const resetForm = () => {
		form.resetFields();
	};

	const onFinish = async (values) => {
		try {
			const post_data = {
				cardType: {
					code: values.card_type,
					name: creditCardTypes.find((i) => i.code === values.card_type).name,
				},
				cardProvider: {
					code: values.card_provider,
					name: creditCardProviders.find((i) => i.code === values.card_provider)
						.name,
				},
				ownerName: values.name,
				number: values.number.replace(/\D/g, ''),
				securityCode: 999,
				dateFrom: null,
				// Se usa selectedExpiry (capturado directamente del onChange del
				// DatePicker) en lugar de values.expiry, ya que este último podía
				// llegar undefined al momento del submit, haciendo que
				// moment(undefined) devuelva la fecha/hora actual en vez de la
				// seleccionada por el usuario. Se fija el día en 1
				// (startOf("month")) porque el picker es de tipo "month" (el
				// usuario solo elige mes/año). Además se usa "YYYY" (mayúscula),
				// que es el token válido de año de 4 dígitos en Moment.js
				// ("yyyy" en minúscula no es reconocido y se imprime literal).
				dateTo: selectedExpiry
					? selectedExpiry.clone().startOf("month").format("YYYY-MM-DD")
					: null,

				type: "creditCardData",
			};
			resetForm();
			setSelectedExpiry(null);
			onCreate(post_data);

		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Inner>
			<Form
				form={form}
				name="create-credit-card-form"
				layout="vertical"
				onFinish={onFinish}
			>
				<FloatingLabel
					label={"Proveedor"}
					value={formValues?.card_provider}
					hint={"Proveedor"}
				>
					<Form.Item
						name="card_provider"
						rules={[
							{
								required: true,
								message: "Campo requerido",
							},
						]}
					>
						<Select
							allowClear={true}
							onChange={(v) => handleInputChange(v, "provider")}
						>
							{creditCardProviders.map((cardProvider) => (
								<Option key={cardProvider.code} value={cardProvider.code}>
									{cardProvider.name}
								</Option>
							))}
						</Select>
					</Form.Item>
				</FloatingLabel>
				<Row gutter={20}>
					<Col span={12}>
						<FloatingLabel
							label={"Tipo de tarjeta"}
							value={formValues?.card_type}
							hint={"Tipo de tarjeta"}
						>
							<Form.Item
								name="card_type"
								rules={[
									{
										required: true,
										message: "Campo requerido",
									},
								]}
							>
								<Select allowClear={true}>
									{creditCardTypes.map((cardType) => (
										<Option key={cardType.code} value={cardType.code}>
											{cardType.name}
										</Option>
									))}
								</Select>
							</Form.Item>
						</FloatingLabel>
					</Col>
					<Col span={12}>
						<FloatingLabel
							label={"Fecha de vencimiento"}
							value={formValues?.expiry}
							hint={"Fecha de vencimiento"}
							style={{ flex: "1 1" }}
						>
							<Form.Item
								name="expiry"
								rules={[
									{
										required: true,
										message: "Campo requerido",
									},
								]}
							>
								<DatePicker
									format="MM/YY"
									allowClear={true}
									style={{ width: "100%" }}
									placeholder=""
									picker="month"
									disabled={!formValues?.card_provider}
									name="expiry"
									onFocus={handleInputFocus}
									onChange={(date) => {
										setSelectedExpiry(date);
										handleInputChange(date, null);
									}}
								/>

							</Form.Item>
						</FloatingLabel></Col>
				</Row>

				<FloatingLabel
					label={"Nombre"}
					value={formValues?.name}
					hint={"Nombre"}
				>
					<Form.Item
						name="name"
						rules={[
							{
								required: true,
								message: "Campo requerido",
							},
							{
								max: 50,
								message: "Maximo 50 caracteres",
							},
						]}
					>
						<Input
							type="text"
							disabled={!formValues?.card_provider}
							onFocus={handleInputFocus}
							onChange={(e) => handleInputChange(e.target.value, e)}
							name="name"
						/>
					</Form.Item>
				</FloatingLabel>

				<FloatingLabel
					label={"Numero de tarjeta"}
					value={formValues?.number}
					hint={"Numero de tarjeta"}
				>
					<Form.Item
						name="number"
						rules={[
							{
								required: true,
								message: "Campo requerido",
							},
							{
								max: 50,
								message: "Maximo 50 caracteres",
							},
							{
								min: 19,
								message: "Minimo 19 caracteres",
							},
						]}
					>
						<Input
							type="text"
							disabled={!formValues?.card_provider}
							name="number"
							onFocus={handleInputFocus}
							onChange={handleChange}
							maxLength={19}
							onKeyDown={(e) =>
								/[A-Za-z]$/.test(e.key) &&
								e.key !== "Backspace" &&
								e.key !== "Control" &&
								e.key !== "v" &&
								e.preventDefault()
							}
						/>
					</Form.Item>
				</FloatingLabel>



				<Form.Item>
					{fixedFooter ? (
						<Footer>
							<Divider />
							<ButtonsFixedFooter>
								<Button
									type="secondary"
									onClick={() => {
										setAddPaymentMethodMode(false);
										onCancel();
									}}
									htmlType="button"
								>
									{"Cancelar"}
								</Button>
								<Button type="primary" htmlType="submit">
									{"Agregar"}
								</Button>
							</ButtonsFixedFooter>
						</Footer>
					) : (
						<Buttons>
							<Button
								type="secondary"
								onClick={() => {
									setAddPaymentMethodMode(false);
									onCancel();
								}}
								htmlType="button"
							>
								{"Cancelar"}
							</Button>
							<Button type="primary" htmlType="submit">
								{"Agregar"}
							</Button>
						</Buttons>
					)}
				</Form.Item>
			</Form>
		</Inner>
	);
}
